import { useMediaQuery } from "@mui/material"
import BenefitsWeb from "./BenefitsWeb"
import BenefitsMob from "./BenefitsMob"
export default function EquityBenefits() {
    const isSmallScreen = useMediaQuery("(max-width:800px)");
    return isSmallScreen ? <BenefitsMob /> : <BenefitsWeb />;

}